module.exports = __webpack_public_path__ + "img/Walk.377da63a.svg";